/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Empty } from "antd";
import { gameList } from "constants/game-list";
import { DeviceScreenWidth } from "enums/device";
import useWindowSize from "hooks/useWindowSize";
import { filter } from "lodash";
import { Fragment, useState } from "react";
import { useLocation } from "react-router-dom";

import PromotionCard from "../PromotionCard";
import { PromotionRenderStyle } from "./index.style";

type Props = {
  data: any[];
  onClick?: (item: any) => void;
};
const dataCategory = [
  {
    name: "HOT",
    code: "HOT",
  },
  ...gameList.map((item) => ({
    name: item.categoryName,
    code: item.categoryCode,
  })),
];
function PromotionRender({ data, onClick }: Props) {
  const { pathname } = useLocation();

  const { width } = useWindowSize();
  const [category, setCategory] = useState<string>("HOT");
  const getData = () => {
    if (category === "HOT") return data;
    return filter(data, (item) => item.category.includes(category));
  };
  const dataFormat = getData();

  return (
    <Fragment>
      <div
        css={css`
          max-width: ${pathname.includes("user") ? "798px" : "none"};
        `}
      >
        <div css={PromotionRenderStyle.categoryMap}>
          {dataCategory.map((item, index) => {
            const isSelected = item.code === category;
            return (
              <div
                onClick={() => setCategory(item.code)}
                className={`item-cate ${isSelected && "selected"}`}
                key={index + "cate"}
              >
                {item.name}
              </div>
            );
          })}
        </div>
        {Array.isArray(data) && data.length ? (
          <div css={PromotionRenderStyle.listPromos}>
            {Array.isArray(dataFormat) &&
              dataFormat.map((item, index) => (
                <div
                  onClick={() => {
                    onClick && onClick(item);
                  }}
                >
                  <PromotionCard
                    key={index}
                    name={item.bonus}
                    image={
                      width > DeviceScreenWidth.MOBILE ? item.mobile : item.web
                    }
                    wager={item.wager}
                    content={item.content}
                    isSubcribe={item.button}
                    link={item.link}
                  />
                </div>
              ))}
          </div>
        ) : (
          <div css={PromotionRenderStyle.empty}>
            <Empty />
          </div>
        )}
      </div>
    </Fragment>
  );
}

export default PromotionRender;
